module.exports = __webpack_public_path__ + "img/hamburger_icon.86595150.svg";